import { memo, useCallback } from "react";
import { CellContext } from "@tanstack/react-table";
import { pluralizeWithCount } from "@common/helpers/string";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { useOverlays } from "contexts/OverlayContext";
import { CatalogItemRow } from "../catalogItems.types";
import { CountButtonCell } from "./CountButtonCell";

export const InvoiceCountCell = memo(function InvoiceCountCell({
    row,
}: CellContext<ViewTableFeatures, CatalogItemRow, unknown>) {
    const { openOverlay } = useOverlays();
    const item = row.original;

    const handleClick = useCallback(
        (event: React.MouseEvent) => {
            event.stopPropagation();
            openOverlay("invoicesDrilldown", {
                filters: { catalogItemIds: [item.id] },
            });
        },
        [openOverlay, item.id],
    );

    if (item.isNew) {
        return <ViewTableCell />;
    }

    const count = item.invoiceCount ?? 0;

    return (
        <CountButtonCell
            count={count}
            ariaLabel={`View ${pluralizeWithCount("invoice", count)} for ${item.name}`}
            onClick={handleClick}
        />
    );
});
